import { Tokens } from '@tmov/design-system/theme/types';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  Text,
  XAxis,
  YAxis,
} from 'recharts';

import {
  formatarPorcentagemAderencia,
  limitarLabel,
  toTitleCase,
} from '../../../../../helpers/formatador';

const BAR_AXIS_SPACE = 80;

let ctx;
const measureText14HelveticaNeue = text => {
  if (!ctx) {
    ctx = document.createElement('canvas').getContext('2d');
    ctx.font = "14px 'Helvetica Neue";
  }

  return ctx.measureText(text).width;
};

const YAxisLeftTick = ({ y, payload: { value } }) => (
  <Text x={0} y={y} textAnchor="start" verticalAnchor="middle" scaleToFit>
    {toTitleCase(limitarLabel(value, 15))}
  </Text>
);

YAxisLeftTick.propTypes = {
  y: PropTypes.number.isRequired,
  payload: PropTypes.shape({
    value: PropTypes.string,
  }).isRequired,
};

function ProdutoBarChart({ data, xKey, yKey }) {
  const maxTextWidth = useMemo(
    () =>
      data.reduce((acc, cur) => {
        const value = cur[yKey];
        const width = measureText14HelveticaNeue(value?.toLocaleString());
        if (width > acc) {
          return width;
        }
        return acc;
      }, 0),
    [data, yKey]
  );

  const formatterBarName = value => {
    if (value && yKey) {
      switch (yKey) {
        case 'aderencia_cadencia':
          return formatarPorcentagemAderencia(value);
        default:
          return value.toLocaleString();
      }
    }

    return value;
  };

  return (
    <ResponsiveContainer width="100%" height={50 * data.length} debounce={50}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{
          left: BAR_AXIS_SPACE - 10,
          right: maxTextWidth + (BAR_AXIS_SPACE - 8),
        }}
      >
        <XAxis hide axisLine={false} type="number" />
        <YAxis
          yAxisId={0}
          dataKey={xKey}
          type="category"
          axisLine={false}
          tickLine={false}
          tick={YAxisLeftTick}
        />
        <YAxis
          orientation="right"
          yAxisId={1}
          dataKey={yKey}
          type="category"
          axisLine={false}
          tickLine={false}
          tickFormatter={value => [formatterBarName(value)]}
          mirror
          tick={{
            transform: `translate(${maxTextWidth + BAR_AXIS_SPACE}, 0)`,
          }}
        />
        <Bar dataKey={yKey} minPointSize={2} barSize={6} radius={4}>
          {data.map(item => (
            <Cell
              key={item[xKey]}
              fill={Tokens.eixods.colors.brand.primary[100]}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

ProdutoBarChart.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  xKey: PropTypes.string.isRequired,
  yKey: PropTypes.string.isRequired,
};

export default ProdutoBarChart;
